import React, { useState, useEffect } from 'react';
import {
    Typography,
    Box,
    CssBaseline,
    Tabs,
    Tab,
    TextField,
    Button,
    Grid,
    InputAdornment, 
    IconButton,
} from '@mui/material';
import axios from 'axios';
import { global_link } from '../Components/Globallink';
import { Visibility, VisibilityOff } from '@mui/icons-material';
// ALERT
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const Profile = () => {
    const api = axios.create({baseURL: global_link});
    const [activeTab, setActiveTab] = useState(0);
    const authToken = process.env.AUTH_TOKEN;
    const authyToken = localStorage.getItem(authToken);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [title, setTitle] = useState('');
    const [level, setLevel] = useState('');
    const [extension, setExtension] = useState('');

    const [oldPass, setOldPass] = useState('');
    const [newPass, setNewPass] = useState('');
    const [confirmPass, setConfirmPass] = useState('');

    const [openUserAlert, setOpenUserAlert] = useState(false);
    const [openUserErrorAlert, setOpenUserErrorAlert] = useState(false);
    const [openUserPass, setOpenUserPass] = useState(false);
    const [openUserPassMatch, setOpenUserPassMatch] = useState(false);
    const [openUserPassIncorrect, setOpenUserPassIncorrect] = useState(false);

    const handleCloseUserAlert = (event, reason) => {
    if (reason === 'clickaway') {return;}setOpenUserAlert(false);}; 

    const handleCloseUserErrorAlert = (event, reason) => {
        if (reason === 'clickaway') {return;}setOpenUserErrorAlert(false);}; 

    const handleClosePassAlert = (event, reason) => {
        if (reason === 'clickaway') {return;}setOpenUserPass(false);}; 

    const handleClosePassMatchAlert = (event, reason) => {
        if (reason === 'clickaway') {return;}setOpenUserPassMatch(false);}; 

    const handleClosePassIncorrectAlert = (event, reason) => {
        if (reason === 'clickaway') {return;}setOpenUserPassIncorrect(false);}; 


    const [state, setState] = useState({open: false,vertical: 'top',horizontal: 'center',});
    const { vertical, horizontal} = state;

    const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

      const [showPassword, setShowPassword] = useState(false);
    
      const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
      const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };

    const headers = {
        'Authorization': `Bearer ${authyToken}`,
        'Content-Type': 'application/json',
      };

    const userInfo = () => {
        const headers = {
            'Authorization': `Bearer ${authyToken}`,
            'Content-Type': 'application/json',
          };
    api.get('/user/user', {
        headers,
        withCredentials: true,
        }).then(response => {
            setName(response.data.user_name);
            setEmail(response.data.user_email);
            setPhone(response.data.user_phone);
            setLevel(response.data.user_level);
            setTitle(response.data.user_title);
            setExtension(response.data.user_extension);
        })
        .catch(error => {
            console.error(error);
        });}
        
    useEffect(() => {
        userInfo();
    }, []);


      const handleUserInfoSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        api.put('/user/userupdate/', formData,{ headers, withCredentials: true})
          .then((response) => {
            setTimeout(() => userInfo(), 500);
            setOpenUserAlert(true);
          })
          .catch((error) => {
            setOpenUserErrorAlert(true);
            console.error(error);
          });
      };

      const handleNameChange = (event) => {
        setName(event.target.value);
      };
    
      const handleEmailChange = (event) => {
        setEmail(event.target.value);
      };
    
      const handlePhoneChange = (event) => {
        setPhone(event.target.value);
      };

      const handleOldPassChange = (event) => {
        setOldPass(event.target.value);
      };
      const handleNewPassChange = (event) => {
        setNewPass(event.target.value);
      };
      const handleConfirmPassChange = (event) => {
        setConfirmPass(event.target.value);
      };

      const resetPasswordFields = () => {
        setOldPass('');
        setNewPass('');
        setConfirmPass('');
      };

      const handlePasswordSubmit = (event) => {
        event.preventDefault();
        if(confirmPass!==newPass){
            setOpenUserPassMatch(true);
            resetPasswordFields();
            return;
        }
        const formData = new FormData(event.target);
        api.put('/user/userupdatepassword/', formData,{ headers, withCredentials: true})
        .then((response) => {
        setActiveTab(1);
        setOpenUserPass(true);
        resetPasswordFields();
        })
        .catch((error) => {
        console.error(error);
        setOpenUserPassIncorrect(true);
        resetPasswordFields();
        });

      }

    return (
<>
<CssBaseline />
    <Typography variant='h5' sx={{marginBottom:'15px'}}>
        Profile
    </Typography>
            <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
                <Box
                    sx={{bgcolor:'background.paper',boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px'}}
                >
<Tabs
  value={activeTab}
  onChange={handleTabChange}
  variant="fullWidth"
   aria-label="Profile Tabs"
   sx={{padding:'2px',}}
      >
        <Tab label="Profile"/>
        <Tab  label="Security"/>
      </Tabs>
      {activeTab === 0 && (
                <Box sx={{ padding: '20px' }}>
                    <Typography variant="h6" sx={{ marginBottom: '15px' }}>
                        Edit Profile
                    </Typography>
                    <form onSubmit={handleUserInfoSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Name"
                                variant="outlined"
                                name="user_name"
                                value={name}
                                onChange={handleNameChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Email"
                                variant="outlined"
                                value={email}
                                name="user_email"
                                type="email"
                                onChange={handleEmailChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="Phone Number"
                                variant="outlined"
                                name="user_phone"
                                value={phone}
                                onChange={handlePhoneChange}

                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="Extension"
                                variant="outlined"
                                name="extension"
                                value={extension}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="Level"
                                name="user_level"
                                variant="outlined"
                                value={level}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="Title"
                                variant="outlined"
                                value={title}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" type="submit">
                                Save Changes
                            </Button>
                        </Grid>
                    </Grid>
                    </form>
                </Box>
            )}
            {activeTab === 1 && (
                <Box sx={{ padding: '20px' }}>
                    <Typography variant="h6" sx={{ marginBottom: '15px' }}>
                        Update Password
                    </Typography>
                    <form onSubmit={handlePasswordSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Current Password"
                                variant="outlined"
                                name="old_pass"
                                value={oldPass}
                                onChange={handleOldPassChange}
                                required
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                        </InputAdornment>
                                    )
                                    }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="New Password"
                                variant="outlined"
                                name="new_pass"
                                value={newPass}
                                onChange={handleNewPassChange}
                                required
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                        </InputAdornment>
                                    )
                                    }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="Confirm New Password"
                                variant="outlined"
                                value={confirmPass}
                                onChange={handleConfirmPassChange}
                                required
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                        </InputAdornment>
                                    )
                                    }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" type='submit'>
                                Update Password
                            </Button>
                        </Grid>
                    </Grid>
                    </form>
                </Box>
            )}

            <Stack spacing={2} sx={{ width: '100%'}}>
            <Snackbar open={openUserErrorAlert} autoHideDuration={6000} onClose={handleCloseUserErrorAlert}  anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
            <Alert onClose={handleCloseUserErrorAlert} severity="error" sx={{ width: '100%' }}>
            Error Updating Information!!!
            </Alert>
            </Snackbar>
            </Stack>

            <Stack spacing={2} sx={{ width: '100%'}}>
            <Snackbar open={openUserAlert} autoHideDuration={6000} onClose={handleCloseUserAlert}  anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
            <Alert onClose={handleCloseUserAlert} severity="success" sx={{ width: '100%' }}>
            User Information Update Success!!!
            </Alert>
            </Snackbar>
            </Stack>

            <Stack spacing={2} sx={{ width: '100%'}}>
            <Snackbar open={openUserPass} autoHideDuration={6000} onClose={handleClosePassAlert}  anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
            <Alert onClose={handleClosePassAlert} severity="success" sx={{ width: '100%' }}>
            Password Update Success!!!
            </Alert>
            </Snackbar>
            </Stack>

            <Stack spacing={2} sx={{ width: '100%'}}>
            <Snackbar open={openUserPassIncorrect} autoHideDuration={6000} onClose={handleClosePassIncorrectAlert}  anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
            <Alert onClose={handleClosePassAlert} severity="error" sx={{ width: '100%' }}>
            Old Password Is Incorrect!
            </Alert>
            </Snackbar>
            </Stack>

            <Stack spacing={2} sx={{ width: '100%'}}>
            <Snackbar open={openUserPassMatch} autoHideDuration={6000} onClose={handleClosePassMatchAlert}  anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
            <Alert onClose={handleClosePassAlert} severity="error" sx={{ width: '100%' }}>
            Passwords Do Not Match!
            </Alert>
            </Snackbar>
            </Stack>

                </Box>
            </Grid>
        </Grid>
</>
    );
};

export default Profile;
